var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col" },
    [
      _c(
        "el-descriptions",
        {
          staticClass: "description",
          attrs: { "label-class-name": "desc-label", column: 3, border: "" },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "药库编码" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["positionCode"]) + " "
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "药库名称" } }, [
            _vm._v(
              " " + _vm._s(_vm.pageData.prescription.head["positionName"]) + " "
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "ik-list-table",
          attrs: {
            stripe: true,
            border: true,
            data: _vm.pageData.prescription.body.medPrescriptionItem,
            height: "300",
            "header-row-class-name": "ik-list-table-header-row",
            "header-cell-class-name": "ik-list-table-header-cell",
            "row-class-name": "ik-list-table-body-row",
            "cell-class-name": "ik-list-table-body-cell",
            "highlight-current-row": true,
          },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "药品编码", prop: "materielName" },
          }),
          _c("el-table-column", {
            attrs: { prop: "materielName", label: "药品名称", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sellingNum", label: "数量", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "medAdvice", label: "医嘱", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "salePrice", label: "单价", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "saleAmount", label: "总价", align: "center" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }